import axios from 'axios'
import {
  DOCUMENT_SIGN_FAIL,
  DOCUMENT_SIGN_REQUEST,
  DOCUMENT_SIGN_SUCCESS,
} from '../constants/documentConstants'

export const signDocument = (project) => async (dispatch, getState) => {
  try {
    dispatch({
      type: DOCUMENT_SIGN_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(
      `/api/document/send-signature-request/${project._id}`,
      config
    )

    dispatch({
      type: DOCUMENT_SIGN_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: DOCUMENT_SIGN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}
